import {useSelector} from "react-redux"
import {useMemo} from "react"

const storeTypeSlots = {
  store_pickup: "pickup_slots",
  delivery: "delivery_slots",
}

export const processStoreTimeSlots = (storeTimeSlots, checkoutStoreType) => {
  const slotKey = storeTypeSlots[checkoutStoreType]
  if (!slotKey || !storeTimeSlots?.[slotKey]) {
    return []
  }

  return storeTimeSlots[slotKey]
    .flatMap(i => i.process_slots || [])
    .map(i => ({
      title: i.shipping_date_day_time,
      value: i,
    }))
}

export default function useStoreTimeSlots() {
  const {storeTimeSlots, checkoutStoreType} = useSelector(
    ({checkout}) => checkout
  )

  const options = useMemo(() => {
    return processStoreTimeSlots(storeTimeSlots, checkoutStoreType)
  }, [storeTimeSlots, checkoutStoreType])

  return options
}
